import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      // 仪表板
      path: '/',
      name: 'dashBoard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashboard'], resolve)
    },

    /** **********************************续期**************************************** **/

    {
      // 个险续期-应收列表
      path: '/shouldReceiveList',
      name: 'shouldReceiveList',
      meta: {
        menu: '/shouldReceiveList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/shouldReceive'], resolve)
    },
    {
      // 个险续期-应收列表-详情
      path: '/shouldReceiveDetail',
      name: 'shouldReceiveDetail',
      meta: {
        menu: '/shouldReceiveList'
      },
      component: resolve => require(['@/pages/shouldReceive/details'], resolve)
    },
    {
      // 个险续期-应收清单打印
      path: '/receivableListPrint',
      name: 'receivableListPrint',
      meta: {
        menu: '/receivableListPrint',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/receivableListPrint'], resolve)
    },
    {
      // 个险续期-缴费通知单打印
      path: '/paymentNotice',
      name: 'paymentNotice',
      meta: {
        menu: '/paymentNotice',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/paymentNotice'], resolve)
    },
    {
      // 个险续期-缴费通知单打印-pdf打印详情
      path: '/pdfDetail/:printInfoId',
      name: 'pdfDetails',
      meta: {
        menu: '/paymentNotice'
      },
      component: resolve => require(['@/pages/paymentNotice/details'], resolve)
    },
    {
      // 缴费通知单打印管理
      path: '/paymentNoticeManage',
      name: 'paymentNoticeManage',
      meta: {
        menu: '/paymentNoticeManage',
        keep: true
      },
      component: resolve => require(['@/pages/paymentNoticeManage'], resolve)
    },
    {
      // 缴费通知单打印管理-打印查询
      path: '/paymentNoticeManageSearch',
      name: 'paymentNoticeManageSearch',
      meta: {
        menu: '/paymentNoticeManage',
        keep: true
      },
      component: resolve => require(['@/pages/paymentNoticeManage/search'], resolve)
    },
    {
      // 缴费通知单打印管理-PDF页
      path: '/pdfDetailManage/:printInfoId',
      name: 'pdfDetailManage',
      meta: {
        menu: '/paymentNoticeManage'
      },
      component: resolve => require(['@/pages/paymentNoticeManage/detail'], resolve)
    },
    {
      // 团险续期-应收列表
      path: '/groupShouldReceiveList',
      name: 'groupShouldReceiveList',
      meta: {
        menu: '/groupShouldReceiveList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupShouldReceive'], resolve)
    },
    {
      // 团险续期-应收列表-详情
      path: '/groupShouldReceiveDetail',
      name: 'groupShouldReceiveDetail',
      meta: {
        menu: '/groupShouldReceiveList'
      },
      component: resolve => require(['@/pages/groupShouldReceive/details'], resolve)
    },

    /** **********************************续保**************************************** **/

    {
      // 续保-续保确认
      path: '/renewalInsuranceComfirmList',
      name: 'renewalInsuranceComfirmList',
      meta: {
        menu: '/renewalInsuranceComfirmList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewalInsuranceComfirm'], resolve)
    },
    {
      // 续期-续保确认-详情
      path: '/renewalInsuranceComfirmDetail',
      name: 'renewalInsuranceComfirmDetail',
      meta: {
        menu: '/renewalInsuranceComfirmList'
      },
      component: resolve => require(['@/pages/renewalInsuranceComfirm/details'], resolve)
    },
    {
      // 续保-续保回执
      path: '/renewalReceipt',
      name: 'renewalReceipt',
      meta: {
        menu: '/renewalReceipt',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewalReceipt'], resolve)
    },
    {
      // 续期-续保回执-详情
      path: '/renewalReceiptDetail',
      name: 'renewalReceiptDetail',
      meta: {
        menu: '/renewalReceiptDetail'
      },
      component: resolve => require(['@/pages/renewalReceipt/details'], resolve)
    },
    {
      // 续保-回执复核
      path: '/receiptReview',
      name: 'receiptReview',
      meta: {
        menu: '/receiptReview',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/receiptReview'], resolve)
    },
    {
      // 续期-回执复核-详情
      path: '/receiptReviewDetail',
      name: 'receiptReviewDetail',
      meta: {
        menu: '/receiptReviewDetail'
      },
      component: resolve => require(['@/pages/receiptReview/details'], resolve)
    },
    {
      // 续保-续保通知书打印
      path: '/renewalInsuranceNotice',
      name: 'renewalInsuranceNotice',
      meta: {
        menu: '/renewalInsuranceNotice',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewalInsuranceNotice'], resolve)
    },
    {
      // 续期-续保通知书打印-pdf打印详情
      path: '/renewalInsurancePdfDetail/:printInfoId',
      name: 'renewalInsurancePdfDetail',
      meta: {
        menu: '/renewalInsuranceNotice'
      },
      component: resolve => require(['@/pages/renewalInsuranceNotice/details'], resolve)
    },
    {
      // 续保确认书打印管理
      path: '/renewalInsuranceNoticeManage',
      name: 'renewalInsuranceNoticeManage',
      meta: {
        menu: '/renewalInsuranceNoticeManage',
        keep: true
      },
      component: resolve => require(['@/pages/renewalInsuranceNoticeManage'], resolve)
    },
    {
      // 续保确认书打印管理-打印查询
      path: '/renewalInsuranceNoticeSearch',
      name: 'renewalInsuranceNoticeSearch',
      meta: {
        menu: '/renewalInsuranceNoticeManage',
        keep: true
      },
      component: resolve => require(['@/pages/renewalInsuranceNoticeManage/search'], resolve)
    },
    {
      // 续保确认书打印管理-PDF页
      path: '/renewalInsurancePdfManageDetail/:printInfoId',
      name: 'renewalInsurancePdfManageDetail',
      meta: {
        menu: '/renewalInsuranceNoticeManage'
      },
      component: resolve => require(['@/pages/renewalInsuranceNoticeManage/detail'], resolve)
    },
    {
      // 续保-续保查询
      path: '/renewalInsuranceQueryList',
      name: 'renewalInsuranceQueryList',
      meta: {
        menu: '/renewalInsuranceQueryList',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewalInsuranceQuery'], resolve)
    },
    {
      // 续期-续保查询-详情
      path: '/renewalInsuranceQueryDetail',
      name: 'renewalInsuranceQueryDetail',
      meta: {
        menu: '/renewalInsuranceQueryList'
      },
      component: resolve => require(['@/pages/renewalInsuranceQuery/details'], resolve)
    },
    {
      // 团险续保-续保审核-列表
      path: '/groupRenewalAudit',
      name: 'groupRenewalAudit',
      meta: {
        menu: '/groupRenewalAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupRenewalAudit'], resolve)
    },
    {
      // 团险续保-续保审核-详情
      path: '/groupRenewalAuditDetail',
      name: 'groupRenewalAuditDetail',
      meta: {
        menu: '/groupRenewalAudit'
      },
      component: resolve => require(['@/pages/groupRenewalAudit/details'], resolve)
    },
    {
      // 团险续保-人工核保-列表
      path: '/groupUnderwrite',
      name: 'groupUnderwrite',
      meta: {
        menu: '/groupUnderwrite',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupUnderwrite'], resolve)
    },
    {
      // 团险续保-人工核保-详情
      path: '/groupUnderwriteDetail',
      name: 'groupUnderwriteDetail',
      meta: {
        menu: '/groupUnderwrite'
      },
      component: resolve => require(['@/pages/groupUnderwrite/details'], resolve)
    },
    {
      // 团险续保-被保人清单打印-列表
      path: '/groupInsuredListPrint',
      name: 'groupInsuredListPrint',
      meta: {
        menu: '/groupInsuredListPrint',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupInsuredListPrint'], resolve)
    },
    {
      // 团险续保-被保人清单打印-详情
      path: '/groupInsuredListPrintDetail/:groupRenewalId',
      name: 'groupInsuredListPrintDetail',
      meta: {
        menu: '/groupInsuredListPrint'
      },
      component: resolve => require(['@/pages/groupInsuredListPrint/details'], resolve)
    },
    {
      // 被保人清单打印管理
      path: '/groupInsuredListPrintManage',
      name: 'groupInsuredListPrintManage',
      meta: {
        menu: '/groupInsuredListPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupInsuredListPrintManage'], resolve)
    },
    {
      // 被保人清单打印管理-打印查询
      path: '/groupInsuredListPrintManageSearch',
      name: 'groupInsuredListPrintManageSearch',
      meta: {
        menu: '/groupInsuredListPrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupInsuredListPrintManage/search'], resolve)
    },
    {
      // 被保人清单打印管理-PDF页
      path: '/groupInsuredListPrintDetailManage/:groupRenewalId',
      name: 'groupInsuredListPrintDetailManage',
      meta: {
        menu: '/groupInsuredListPrintManage'
      },
      component: resolve => require(['@/pages/groupInsuredListPrintManage/detail'], resolve)
    },
    {
      // 团险续保-续保合同打印-列表
      path: '/groupRenewalNoticePrint',
      name: 'groupRenewalNoticePrint',
      meta: {
        menu: '/groupRenewalNoticePrint',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupRenewalNoticePrint'], resolve)
    },
    {
      // 团险续保-续保合同打印-详情
      path: '/groupRenewalNoticePrintDetail/:groupRenewalId',
      name: 'groupRenewalNoticePrintDetail',
      meta: {
        menu: '/groupRenewalNoticePrint'
      },
      component: resolve => require(['@/pages/groupRenewalNoticePrint/details'], resolve)
    },
    {
      // 续保合同打印管理
      path: '/groupRenewalNoticePrintManage',
      name: 'groupRenewalNoticePrintManage',
      meta: {
        menu: '/groupRenewalNoticePrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupRenewalNoticePrintManage'], resolve)
    },
    {
      // 续保合同打印管理-打印查询
      path: '/groupRenewalNoticePrintManageSearch',
      name: 'groupRenewalNoticePrintManageSearch',
      meta: {
        menu: '/groupRenewalNoticePrintManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupRenewalNoticePrintManage/search'], resolve)
    },
    {
      // 续保合同打印管理-PDF页
      path: '/groupRenewalNoticePrintDetailManage/:groupRenewalId',
      name: 'groupRenewalNoticePrintDetailManage',
      meta: {
        menu: '/groupRenewalNoticePrintManage'
      },
      component: resolve => require(['@/pages/groupRenewalNoticePrintManage/detail'], resolve)
    },
    {
      // 续保-团险续保回执
      path: '/groupReceipt',
      name: 'groupReceipt',
      meta: {
        menu: '/groupReceipt',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupReceipt'], resolve)
    },
    {
      // 续期-团险续保回执-详情
      path: '/groupReceiptDetail',
      name: 'groupReceiptDetail',
      meta: {
        menu: '/groupReceiptDetail'
      },
      component: resolve => require(['@/pages/groupReceipt/details'], resolve)
    },
    {
      // 续保-团险回执复核
      path: '/groupReceiptReview',
      name: 'groupReceiptReview',
      meta: {
        menu: '/groupReceiptReview',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupReceiptReview'], resolve)
    },
    {
      // 续期-团险回执复核-详情
      path: '/groupReceiptReviewDetail',
      name: 'groupReceiptReviewDetail',
      meta: {
        menu: '/groupReceiptReviewDetail'
      },
      component: resolve => require(['@/pages/groupReceiptReview/details'], resolve)
    },
    {
      // 团险续保-续保查询-列表
      path: '/groupRenewalQuery',
      name: 'groupRenewalQuery',
      meta: {
        menu: '/groupRenewalQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupRenewalQuery'], resolve)
    },
    {
      // 团险续保-续保查询-详情
      path: '/groupRenewalQueryDetail',
      name: 'groupRenewalQueryDetail',
      meta: {
        menu: '/groupRenewalQuery'
      },
      component: resolve => require(['@/pages/groupRenewalQuery/details'], resolve)
    },
    {
      // 团险续保-续保查询-列表
      path: '/groupAttachmentManage',
      name: 'groupAttachmentManage',
      meta: {
        menu: '/groupAttachmentManage',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/groupAttachmentManage'], resolve)
    },
    {
      // 团险续保-续保查询-详情
      path: '/groupAttachmentManageDetails/:id',
      name: 'groupAttachmentManageDetails',
      meta: {
        menu: '/groupAttachmentManage'
      },
      component: resolve => require(['@/pages/groupAttachmentManage/details'], resolve)
    },
    // 续保
    {
      path: '/groupRenewal',
      name: 'renewalList',
      meta: {
        menu: '/groupRenewal',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/renewal'], resolve)
    },
    // 续保流程
    {
      path: '/renewalStep/:step',
      name: 'renewalStep',
      meta: {
        menu: '/groupRenewal'
      },
      component: resolve => require(['@/pages/renewal/step'], resolve)
    },
    // 续保详情
    {
      path: '/renewalDetail',
      name: 'renewalDetail',
      meta: {
        menu: '/groupRenewal'
      },
      component: resolve => require(['@/pages/renewal/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js